import { useContext } from 'react'
import { ServiceWorkerContext } from '../contexts/ServiceWorkerContextDef'

export const useServiceWorker = () => {
  const context = useContext(ServiceWorkerContext)
  if (!context) {
    throw new Error('useServiceWorker must be used within ServiceWorkerProvider')
  }
  return context
}
